import React from 'react';

const MenuItem = ({isActive, text}) => {
	
	return (
		<li className={isActive ? "active" : "link"}>
			{text}
		</li>
	)
}

export default MenuItem